// attendence
export const UPDATE_ATTENDENCE = 'UPDATE_ATTENDENCE';
export const UPDATE_CALL_CONTROL_BEHAVIOR = 'UPDATE_CALL_CONTROL_BEHAVIOR';
export const UPDATE_AFTER_ATTENDANCE_BEHAVIOR =
  'UPDATE_AFTER_ATTENDANCE_BEHAVIOR';
export const SET_ATTENDANCE_DETAILS = 'SET_ATTENDANCE_DETAILS';
export const SET_ATTENDANCE_DETAILS_DTO = 'SET_ATTENDANCE_DETAILS_DTO';
export const SET_USER_ADDED = 'SET_USER_ADDED';
export const UPDATE_ATTENDANCE_TIME_INFORMATIONS =
  'UPDATE_ATTENDANCE_TIME_INFORMATIONS';
export const RESET_ATETENDANCE = 'RESET_ATETENDANCE';
export const UPDATE_AVATAR_ATTENDANCE = 'UPDATE_AVATAR_ATTENDANCE';
export const UPDATE_AGENT_DEFAULT_CAMPAIGN = 'UPDATE_AGENT_DEFAULT_CAMPAIGN';

// agents
export const UPDATE_AVAILABLE_AGENTS = 'UPDATE_AVAILABLE_AGENTS';
export const UPDATE_LIST_AGENTS_QUEUE = 'UPDATE_LIST_AGENTS_QUEUE';
export const RESET_AGENTS = 'RESET_AGENTS';
export const CLEAR_AGENT_HISTORY = 'CLEAR_AGENT_HISTORY';
export const SET_HISTORY_FOR_AGENT = 'SET_HISTORY_FOR_AGENT';

// auth
export const DELETE_TOKEN = 'DELETE_TOKEN';

// channels
export const UPDATE_CHANNEL_WHATSAPP_STATUS = 'UPDATE_CHANNEL_WHATSAPP_STATUS';
export const UPDATE_CHANNEL_VOICE_STATUS = 'UPDATE_CHANNEL_VOICE_STATUS';
export const UPDATE_CHAT_STATUS = 'UPDATE_CHAT_STATUS';
export const RESET_CHANNEL = 'RESET_CHANNEL';
export const CONNECT_CHAT_VISOR = 'CONNECT_CHAT_VISOR';
export const UPDATE_WHATSAPPS_ON_HOLD = 'UPDATE_WHATSAPPS_ON_HOLD';
export const SET_VOICE_ON_HOLD = 'SET_VOICE_ON_HOLD';
export const UPDATE_CHAT_ON_HOLD = 'UPDATE_CHAT_ON_HOLD';
export const SET_SHEDULED_PAUSE_NAME = 'SET_SHEDULED_PAUSE_NAME';

// chat
export const SET_CHAT_QUEUES = 'SET_CHAT_QUEUES';

// contact
export const SET_CONTACT = 'SET_CONTACT';
export const SET_CONTACT_COLUMNS = 'SET_CONTACT_COLUMNS';
export const SET_MODAL_OPENED = 'SET_MODAL_OPENED';
export const SET_CONTENT_SEARCH = 'SET_CONTENT_SEARCH';
export const SET_MODAL_ACTION = 'SET_MODAL_ACTION';
export const SET_HISTORY_FOR_CONTACT = 'SET_HISTORY_FOR_CONTACT';
export const UPDATE_PARAMS_HISTORY_CONTACT = 'UPDATE_PARAMS_HISTORY_CONTACT';
export const RESET_CONTACT = 'RESET_CONTACT';
export const SET_CONTACTS_FOUND_JOB = 'SET_CONTACTS_FOUND_JOB';
export const SELECT_CONTACT_CONTACTS_FOUND = 'SELECT_CONTACT_CONTACTS_FOUND';
export const CLEAR_CONTACTS_FOUND = 'CLEAR_CONTACTS_FOUND';
export const UPDATE_CONTACT_FOUND = 'UPDATE_CONTACT_FOUND';
export const SHOW_SUMMARY_DIALOG = 'SHOW_SUMMARY_DIALOG';
export const SET_CONTACT_HISTORY = 'SET_CONTACT_HISTORY';
export const SET_FIELDS_CONTACT_CATEGORY = 'SET_FIELDS_CONTACT_CATEGORY';
export const SET_LOADING_HISTORY = 'SET_LOADING_HISTORY';
export const SET_CONTACT_FILTER = 'SET_CONTACT_FILTER';
export const SET_CONTACT_FILTER_TYPE = 'SET_CONTACT_FILTER_TYPE';
export const SET_CONTACT_LATEST_CHURN_RISK = 'SET_CONTACT_LATEST_CHURN_RISK';
export const SET_CONTACT_TAGS = 'SET_CONTACT_TAGS';
// system
export const RESTORE_MUTATION = 'RESTORE_MUTATION';
export const SET_VALIDATOR = 'SET_VALIDATOR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const RESET_SNACKBAR = 'RESET_SNACKBAR';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_DISPLAY_USER_CONFIGURATIONS =
  'SET_DISPLAY_USER_CONFIGURATIONS';
export const NEW_NOTIFICAION = 'NEW_NOTIFICAION';
export const RESET_SYSTEM = 'RESET_SYSTEM';
export const SET_SERVER_TIME = 'SET_SERVER_TIME';
export const SET_SHOW_DASHBOARD = 'SET_SHOW_DASHBOARD';
export const SET_QUEUE_LISTENER_MESSAGE_BROKER =
  'SET_QUEUE_LISTENER_MESSAGE_BROKER';
export const ADD_ALERT_NOT_READ = 'ADD_ALERT_NOT_READ';
export const CLEAN_ALERT_NOT_READ = 'CLEAN_ALERT_NOT_READ';
export const SET_SYSTEM_FILE = 'SET_SYSTEM_FILE';
export const SET_EDITED_FIELDS = 'SET_EDITED_FIELDS';
export const UPDATE_EDITED_FIELDS = 'UPDATE_EDITED_FIELDS';

// whatsapp
export const UPDATE_WHATSAPP_QUEUES = 'UPDATE_WHATSAPP_QUEUES';
export const RESET_WHATSAPP = 'RESET_WHATSAPP';
/* export const SET_ATTACHMENT_DRAWER = 'SET_ATTACHMENT_DRAWER'
export const SET_ATTACHMENT_CAROUSEL = 'SET_ATTACHMENT_CAROUSEL' */
export const SET_WHATSAPP_ALL_MIDIA = 'SET_WHATSAPP_ALL_MIDIA';
/* export const SET_WHATSAPP_NEW_MIDIA = 'SET_WHATSAPP_NEW_MIDIA' */
export const SET_SEARCH_CONVERSATION_DRAWER = 'SET_SEARCH_CONVERSATION_DRAWER';
export const SET_CONVERSATION_LIST = 'SET_CONVERSATION_LIST';
export const SET_CONVERSATION_BY_PROTOCOL = 'SET_CONVERSATION_BY_PROTOCOL';
export const SET_MEDIA_GALLERY_DIALOG = 'SET_MEDIA_GALLERY_DIALOG';
export const SET_FORWARD_MESSAGE_DIALOG = 'SET_FORWARD_MESSAGE_DIALOG';
export const SET_FORWARD_MESSAGE_INITIALIZED =
  'SET_FORWARD_MESSAGE_INITIALIZED';
export const SET_FORWARD_MESSAGE_SELECTION = 'SET_FORWARD_MESSAGE_SELECTION';
export const CLEAR_FORWARD_MODULE = 'CLEAR_FORWARD_MODULE';
export const SET_ACTIVE_SESSION_STATUS = 'SET_ACTIVE_SESSION_STATUS';
export const SET_FORWARD_MESSAGE_PROTOCOL = 'SET_FORWARD_MESSAGE_PROTOCOL';
export const ADD_MESSAGE_ANSWERED = 'ADD_MESSAGE_ANSWERED';

// jobs
export const ADD_NEW_JOB = 'ADD_NEW_JOB';
export const UPDATE_JOB_JOB_LIST = 'UPDATE_JOB_JOB_LIST';
export const RESET_JOBS = 'RESET_JOBS';
export const SET_JOBS = 'SET_JOBS';
export const SET_JOBS_PAGINATED = 'SET_JOBS_PAGINATED';
export const SET_ACTIVE_JOB = 'SET_ACTIVE_JOB';
export const ADD_MESSAGE_TO_JOB = 'ADD_MESSAGE_TO_JOB';
export const ADD_MESSAGE_TO_JOB_BY_IDENTIFIER =
  'ADD_MESSAGE_TO_JOB_BY_IDENTIFIER';
export const ADD_MESSAGE_TO_JOB_BY_PROTOCOL = 'ADD_MESSAGE_TO_JOB_BY_PROTOCOL';
export const UPDATE_ACTIVE_JOB = 'UPDATE_ACTIVE_JOB';
export const UPDATE_CONTACT_ACTIVE_JOB = 'UPDATE_CONTACT_ACTIVE_JOB';
export const UPDATE_CONTACT_COLUMNS_ACTIVE_JOB =
  'UPDATE_CONTACT_COLUMNS_ACTIVE_JOB';
export const REMOVE_JOB_FROM_LIST = 'REMOVE_JOB_FROM_LIST';
export const DISABLE_JOB = 'DISABLE_JOB';
export const SET_SCRIPT_ACTIVE_JOB = 'SET_SCRIPT_ACTIVE_JOB';
export const SET_FIELDS_SCRIPT_ACTIVE_JOB = 'SET_FIELDS_SCRIPT_ACTIVE_JOB';
export const ADD_TAG_TAGS_ATTENDANCE = 'ADD_TAG_TAGS_ATTENDANCE';
export const REMOVE_TAG_TAGS_ATTENDANCE = 'REMOVE_TAG_TAGS_ATTENDANCE';
export const SET_MESSAGES_ON_JOB_HISTORY_FROM_ACTIVE_JOB =
  'SET_MESSAGES_ON_JOB_HISTORY_FROM_ACTIVE_JOB';
export const NEW_MESSAGE_NOT_READ = 'NEW_MESSAGE_NOT_READ';
export const RESET_MESSAGES_NOT_READ = 'RESET_MESSAGES_NOT_READ';
export const SET_SCROLL_TOP = 'SET_SCROLL_TOP';
export const ALTER_FIELD_SCRIPT = 'ALTER_FIELD_SCRIPT';
export const UPDATE_STATUS_MESSAGE = 'UPDATE_STATUS_MESSAGE';
export const SET_NOTIFICATIONS_ACTIVEJOB = 'SET_NOTIFICATIONS_ACTIVEJOB';
export const SET_HISTORY_ACTIVE_JOB = 'SET_HISTORY_ACTIVE_JOB';
export const SET_MESSAGES_FROM_HISTORY = 'SET_MESSAGES_FROM_HISTORY';
export const CLEAR_CONTACT_HISTORY = 'CLEAR_CONTACT_HISTORY';
export const NEW_COLUMN_CONTACT_COLUMNS_JOB = 'NEW_COLUMN_CONTACT_COLUMNS_JOB';
export const UPDATE_JOB_CONTACT = 'UPDATE_JOB_CONTACT';
export const UPDATE_JOB_CONTACT_COLUMNS = 'UPDATE_JOB_CONTACT_COLUMNS';
export const SET_SHOW_TABS = 'SET_SHOW_TABS';
export const SET_TAGS_JOB = 'SET_TAGS_JOB';
export const FORCE_UPDATE_JOB = 'FORCE_UPDATE_JOB';
export const UPDATE_JOB = 'UPDATE_JOB';
export const SET_MESSAGES_JOB = 'SET_MESSAGES_JOB';
export const SET_CLIENT_TYPING = 'SET_CLIENT_TYPING';
export const SET_CLIENT_STATUS = 'SET_CLIENT_STATUS';
export const CLEAR_PROTOCOL = 'CLEAR_PROTOCOL';
export const SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR =
  'SET_JOB_TIMES_INFORMATIONS_COMMUNICATOR';
export const NEW_MANUAL_ACTIVATION = 'NEW_MANUAL_ACTIVATION';
export const DELETE_MANUAL_ACTIVATION = 'DELETE_MANUAL_ACTIVATION';
export const ADD_MESSAGES_HISTORY_JOB = 'ADD_MESSAGES_HISTORY_JOB';
export const INCREMENT_PAGE_HISTORY_MESSAGE = 'INCREMENT_PAGE_HISTORY_MESSAGE';
export const UPDATE_MESSAGE_JOB_BY_CUSTOM_ID =
  'UPDATE_MESSAGE_JOB_BY_CUSTOM_ID';
export const ADD_LAST_CONTACT = 'ADD_LAST_CONTACT';
export const SET_TRANSFERS_HISTORY = 'SET_TRANSFERS_HISTORY';
export const SAVE_UNATTENDED_MESSAGE = 'SAVE_UNATTENDED_MESSAGE';
export const DELETE_UNATTENDED_MESSAGES = 'DELETE_UNATTENDED_MESSAGES';
export const WHATSAPP_NUMBER_NOT_EXISTS = 'WHATSAPP_NUMBER_NOT_EXISTS';
export const DISABLE_CONVERSATION_TAB = 'DISABLE_CONVERSATION_TAB';
export const ENABLE_CONVERSATION_TAB = 'ENABLE_CONVERSATION_TAB';
export const DISABLE_CONVERSATION_OPTIONS = 'DISABLE_CONVERSATION_OPTIONS';
export const ENABLE_CONVERSATION_OPTIONS = 'ENABLE_CONVERSATION_OPTIONS';
export const DISABLE_JOB_TEMPLATE_CONVERSATION =
  'DISABLE_JOB_TEMPLATE_CONVERSATION';
export const ENABLE_JOB_TEMPLATE_CONVERSATION =
  'ENABLE_JOB_TEMPLATE_CONVERSATION';
export const SET_TRANSFER_ASSISTED = 'SET_TRANSFER_ASSISTED';
export const SET_TRANSFER_ASSISTED_ACCEPTED = 'SET_TRANSFER_ASSISTED_ACCEPTED';
export const SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION =
  'SET_TRANSFER_ASSISTED_WAITING_CONFIRMATION';
export const SET_WHATSAPP_KEEP_ALIVE = 'SET_WHATSAPP_KEEP_ALIVE';
export const DISABLED_JOB_ITEMS = 'DISABLED_JOB_ITEMS';
export const CLEAR_JOBS = 'CLEAR_JOBS';
export const ADD_ATTENDANCE_JOB = 'ADD_ATTENDANCE_JOB';

// jobs/messageToSend
export const UPDATE_MESSAGE_TO_SEND_BY_JOB = 'UPDATE_MESSAGE_TO_SEND_BY_JOB';

// qualify
export const RESET_QUALIFY = 'RESET_QUALIFY';
export const UPDATE_QUALIFICATIONS = 'UPDATE_QUALIFICATIONS';

// preset-messages
export const RESET_PRESET_MESSAGES = 'RESET_PRESET_MESSAGES';
export const SET_PRESET_MESSAGES = 'SET_PRESET_MESSAGES';

// pause
export const UPDATE_ACTIVE_PAUSE = 'UPDATE_ACTIVE_PAUSE';
export const UPDATE_PAUSE_ALERTS = 'UPDATE_PAUSE_ALERTS';
export const SET_ALERTED_PAUSE = 'SET_ALERTED_PAUSE';
export const SET_PAUSES = 'SET_PAUSES';

// tags
export const SET_TAGS = 'SET_TAGS';
export const ADD_NEW_TAG = 'ADD_NEW_TAG';
export const ADD_TAG_TO_CONTACT = 'ADD_TAG_TO_CONTACT';
export const ADD_TAG_TO_EMPLOYER = 'ADD_TAG_TO_EMPLOYER';
export const ADD_TAG_TO_ATTENDANCE = 'ADD_TAG_TO_ATTENDANCE';
export const DELETE_TAG_FROM_CONTACT = 'DELETE_TAG_FROM_CONTACT';
export const DELETE_TAG_FROM_EMPLOYER = 'DELETE_TAG_FROM_EMPLOYER';
export const DELETE_TAG_TO_ATTENDANCE = 'DELETE_TAG_TO_ATTENDANCE';
export const SET_ATTENDANCE_TAGS_JOB = 'SET_ATTENDANCE_TAGS_JOB';
export const SET_CONTACT_TAGS_FOR_CONTACT = 'SET_CONTACT_TAGS_FOR_CONTACT';
export const SET_EMPLOYER_TAGS_FOR_EMPLOYER = 'SET_EMPLOYER_TAGS_FOR_EMPLOYER';

// observartion
export const ADD_OBSERVATION = 'ADD_OBSERVATION';
export const CLEAR_OBSERVATION = 'CLEAR_OBSERVATION';

// bots
export const UPDATE_BOTS = 'UPDATE_BOTS';

// voice
export const SET_VOICE_QUEUES = 'SET_VOICE_QUEUES';
export const SET_AGENTS_VOICE_QUEUE = 'SET_AGENTS_VOICE_QUEUE';
export const SET_AGENTS_VOICE_CAMPAIGN = 'SET_AGENTS_VOICE_CAMPAIGN';
export const SET_CAMPAIGNS_VOICE_AGENT = 'SET_CAMPAIGNS_VOICE_AGENT';
export const SET_DIALOG_EXTEN = 'SET_DIALOG_EXTEN';
export const ADD_MESSAGE_ERROR_DIALING = 'ADD_MESSAGE_ERROR_DIALING';
export const ADD_MESSAGE_STATUS = 'ADD_MESSAGE_STATUS';
export const ADD_CURRENT_PROTOCOL = 'ADD_CURRENT_PROTOCOL';

// chat-visor
export const NEW_CHATVISOR = 'NEW_CHATVISOR';
export const NEW_MESSAGE_CHAT_VISOR = 'NEW_MESSAGE_CHAT_VISOR';
export const NEW_MESSAGE_CHATVISOR_CONVERSATION =
  'NEW_MESSAGE_CHATVISOR_CONVERSATION';
export const REMOVE_CONVERSATION = 'REMOVE_CONVERSATION';
export const SET_VIEW_LIST_SUPERVISORS = 'SET_VIEW_LIST_SUPERVISORS';
export const SET_SUPERVISOR_CONNECTED_ON_CHAT =
  'SET_SUPERVISOR_CONNECTED_ON_CHAT';
export const RESET_CHATVISOR = 'RESET_CHATVISOR';

// whatsapp-campaigns
export const SET_AGENT_WHATSAPP_CAMPAIGNS = 'SET_AGENT_WHATSAPP_CAMPAIGNS';
export const RESET_AGENT_WHATSAPP_CAMPAIGNS = 'RESET_AGENT_WHATSAPP_CAMPAIGNS';

// pause/dialog-control
export const PAUSE_DIALOG_CONTROL_OPENED = 'PAUSE_DIALOG_CONTROL_OPENED';
export const PAUSE_DIALOG_CONTROL_TYPE = 'PAUSE_DIALOG_CONTROL_TYPE';
export const CLEAR_DIALOG_CONTROL = 'CLEAR_DIALOG_CONTROL';

// fast-job
export const RESET_FAST_JOB_DIALOGS = 'RESET_FAST_JOB_DIALOGS';
export const SET_DIALOG_FAST_JOB = 'SET_DIALOG_FAST_JOB';

// Inbox Jobs
export const ADD_INBOX_JOB = 'ADD_INBOX_JOB';
export const REMOVE_INBOX_JOB = 'REMOVE_INBOX_JOB';
export const ADD_INBOX_IN_PROCCESS = 'ADD_INBOX_IN_PROCCESS';
export const REMOVE_INBOX_IN_PROCCESS = 'REMOVE_INBOX_IN_PROCCESS';
export const SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION =
  'SET_NEW_WHATSAPP_MESSAGE_NOTIFICATION';

// dialogs
export const SET_DIALOG_RECONNECTING_INFORMATION =
  'SET_DIALOG_RECONNECTING_INFORMATION';
export const SET_DIALOG_TRANSFER_CALL_RECEIVED =
  'SET_DIALOG_TRANSFER_CALL_RECEIVED';
export const SET_DIALOG_PAUSE_ALERT = 'SET_DIALOG_PAUSE_ALERT';

// attendance groups
export const GET_ATTENDANCE_GROUPS = 'GET_ATTENDANCE_GROUPS';

// broadcast
export const SET_ORG_UNIT_INFORMATION = 'SET_ORG_UNIT_INFORMATION';
export const SET_BROADCAST_WHATSAPP_LIST = 'SET_BROADCAST_WHATSAPP_LIST';
export const SHOW_CREATE_NEW_BROADCAST = 'SHOW_CREATE_NEW_BROADCAST';
export const SHOW_BROADCAST_CONTACT_LIST = 'SHOW_BROADCAST_CONTACT_LIST';
export const SHOW_BROADCAST_CANCEL_DIALOG = 'SHOW_BROADCAST_CANCEL_DIALOG';
export const SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG =
  'SHOW_BROADCAST_WHATSAPP_TEMPLATE_DIALOG';
export const REMOVE_BROADCAST_FROM_LIST = 'REMOVE_BROADCAST_FROM_LIST';
export const ADD_BROADCAST = 'ADD_BROADCAST';
export const UPDATE_BROADCAST_STATUS = 'UPDATE_BROADCAST_STATUS';
export const SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE =
  'SET_BROADCAST_WHATSAPP_TEMPLATE_MESSAGE';
export const SET_BROADCAST_CONTACTS_SELECTED =
  'SET_BROADCAST_CONTACTS_SELECTED';
// whatsapp-templates
export const SET_WHATSAPP_TEMPLATE_SENT = 'SET_WHATSAPP_TEMPLATE_SENT';

// ackCallRequest
export const SET_ACK_CALL_REQUEST_DIALOG = 'SET_ACK_CALL_REQUEST_DIALOG';
export const SET_ACK_CALL_REQUEST_INFORMATION =
  'SET_ACK_CALL_REQUEST_INFORMATION';
export const SET_ACK_CALL_REQUEST_IN_PROGRESS =
  'SET_ACK_CALL_REQUEST_IN_PROGRESS';
export const RESET_ACK_CALL_REQUEST_DIALOG = 'RESET_ACK_CALL_REQUEST_DIALOG';
export const UPDATE_ACK_CALL_REQUEST = 'UPDATE_ACK_CALL_REQUEST';
export const UPDATE_ACK_CALL_VOLUME = 'UPDATE_ACK_CALL_VOLUME';
export const UPDATE_WEBRTC_AUTO_RECONNECT = 'UPDATE_WEBRTC_AUTO_RECONNECT';

// Reconexão
/* Mutations responsáveis pelos indicadores de status e de popup de perda de conexão */
export const INTERNET_CONNECTION_AVAILABLE = 'INTERNET_CONNECTION_AVAILABLE';
export const WEON_CONNECTION_AVAILABLE = 'WEON_CONNECTION_AVAILABLE';
export const RECONNECTION_CONFIRMATION = 'RECONNECTION_CONFIRMATION';
export const CONNECTION_PROBLEM_DIALOG = 'CONNECTION_PROBLEM_DIALOG';
export const BACKUP_CURRENT_PROTOCOL_JOBS = 'BACKUP_CURRENT_PROTOCOL_JOBS';
export const CLEAN_CURRENT_JOBS = 'CLEAN_CURRENT_JOBS';
export const CLEAN_BACKUP_PROTOCOLS = 'CLEAN_BACKUP_PROTOCOLS';
export const CONNECTION_PROBLEM_WEBRTC = 'CONNECTION_PROBLEM_WEBRTC';
export const CONNECTION_WEBRTC_STATUS = 'CONNECTION_WEBRTC_STATUS';
export const SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT =
  'SET_LATEST_VOICE_STATUS_BEFORE_DISCONNECT';
export const CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST =
  'CONNECTION_WEBRTC_DEVICE_CONNECTION_LOST';

// Employers
/* Mutations responsáveis por carregar a lista de empresas e cargos */
export const SET_EMPLOYERS_AND_ROLES = 'SET_EMPLOYERS_AND_ROLES';
export const SET_EMPLOYER_DIALOG = 'SET_EMPLOYER_DIALOG';
export const SET_EMPLOYER_CONTACTS = 'SET_EMPLOYER_CONTACTS';

// Campaigns (WEON 5.0)
export const SET_CAMPAIGN_VOICE_LIST = 'SET_CAMPAIGN_VOICE_LIST';
export const SET_EMPLOYER_CODE = 'SET_EMPLOYER_CODE';
export const SET_EMPLOYER_CNPJ = 'SET_EMPLOYER_CNPJ';
export const SET_EMPLOYER_SOCIAL_NAME = 'SET_EMPLOYER_SOCIAL_NAME';

export const SET_MENU_SELECTED = 'SET_MENU_SELECTED';

// Colleagues
export const SET_COLLEAGUES_LIST = 'SET_COLLEAGUES_LIST';
export const SET_COLLEAGUES_STATUS = 'SET_COLLEAGUES_STATUS';
export const RESET_COLLEAGUES_STATE = 'RESET_COLLEAGUES_STATE';

export const SET_COLLEAGUES_CALL_RINGING = 'SET_COLLEAGUES_CALL_RINGING';
export const SET_COLLEAGUES_CALL_IN_PROGRESS =
  'SET_COLLEAGUES_CALL_IN_PROGRESS';
export const SET_COLLEAGUES_CALL_HANGUP = 'SET_COLLEAGUES_CALL_HANGUP';
export const SET_COLLEAGUES_CALL_STATUS = 'SET_COLLEAGUES_CALL_STATUS';
export const SHOW_COLLEAGUES_CALL_RINGING_CARD =
  'SHOW_COLLEAGUES_CALL_RINGING_CARD';
export const SHOW_COLLEAGUES_CALL_INPROGRESS_CARD =
  'SHOW_COLLEAGUES_CALL_INPROGRESS_CARD';
export const RESET_COLLEAGUES_CALL_CARDS = 'RESET_COLLEAGUES_CALL_CARDS';

// Organia
export const SET_ORGANIA_OPEN_URL_DIALOG = 'SET_ORGANIA_OPEN_URL_DIALOG';
export const SET_ORGANIA_DONT_ASK_AGAIN = 'SET_ORGANIA_DONT_ASK_AGAIN';

export const SET_WHITELABEL = 'SET_WHITELABEL';

// Agent Absent
export const SET_AGENT_ABSENT = 'SET_AGENT_ABSENT';
export const UPDATE_AGENT_ABSENT_STATUS = 'UPDATE_AGENT_ABSENT_STATUS';
export const SET_DIALOG_AGENT_ABSENT = 'SET_DIALOG_AGENT_ABSENT';

// notifications
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
export const REMOVE_CONVERSATION_LIST = 'REMOVE_CONVERSATION_LIST';
export const SET_ATTENDANCE_INFORMATIONS_COMMUNICATOR =
  'SET_ATTENDANCE_INFORMATIONS_COMMUNICATOR';
export const SET_JOB_CHANNEL = 'SET_JOB_CHANNEL';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';

// FEATURE-FLAGS
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';

export const SET_VIEW_MODAL_FEEDBACK = 'SET_VIEW_MODAL_FEEDBACK';

export const RESET_AGENT_UNREAD_MESSAGES = 'RESET_AGENT_UNREAD_MESSAGES';

export const SET_LAST_MESSAGE = 'SET_LAST_MESSAGE';
